export const LOGIN = "/";
export const DASHBOARD = "/dashboard";
export const ABOUT = '/about';
export const CONTACT_US = '/contactUs';
export const TRAINING = "/trailing";
export const LIST_VIEW = "/listView";
export const WEEKLY_VIEW = '/weeklyView';
export const DAILY_VIEW = '/dailyView';
export const MONTHLY_VIEW = '/monthlyView';
export const LOGIN_CALLBACK = '/login/callback'
export const SEARCH_INFO = '/searchInfo'



export const JOEI_FILTERS_TUTORIAL = "https://player.vimeo.com/video/1080860560?h=a5ab3afc6a&badge=0&autopause=0&player_id=0&app_id=58479"
export const CATEGORY_VIEW_VIDEO = "https://player.vimeo.com/video/1080864072?h=9133e55c2c&badge=0&autopause=0&player_id=0&app_id=58479"
export const UNIVERSAL_SEARCH_VIDEO = "https://player.vimeo.com/video/1080924811?h=d4b82bfbee&badge=0&autopause=0&player_id=0&app_id=58479"
export const CALENDAR_VIEW_VIDEO = "https://player.vimeo.com/video/1080849918?h=ffdb474e14&badge=0&autopause=0&player_id=0&app_id=58479"


//videoLinks
export const VIDEO_LINKS = {
    JOEI_FILTERS_TUTORIAL: "https://player.vimeo.com/video/1080860560?h=a5ab3afc6a&badge=0&autopause=0&player_id=0&app_id=58479",
    CATEGORY_VIEW_VIDEO: "https://player.vimeo.com/video/1080864072?h=9133e55c2c&badge=0&autopause=0&player_id=0&app_id=58479",
    UNIVERSAL_SEARCH_VIDEO: "https://player.vimeo.com/video/1080924811?h=d4b82bfbee&badge=0&autopause=0&player_id=0&app_id=58479",
    CALENDAR_VIEW_VIDEO: "https://player.vimeo.com/video/1080849918?h=ffdb474e14&badge=0&autopause=0&player_id=0&app_id=58479",
};

// jobAidLink
export const JOEI_FILTERS_TUTORIAL_AID = "https://trello.com/1/cards/674f4bdc35bd7c62478db41e/attachments/6818fa3fadab6b4e7b89d545/download/JOEI_Training-_Filters.pdf"
export const CATEGORY_VIEW_AID = "https://trello.com/1/cards/674f4bdc35bd7c62478db41e/attachments/681a1700db9d3605eaf4765d/download/JOEI_Training-_Category_View.pdf"
export const UNIVERSAL_SEARCH_AID = "https://trello.com/1/cards/674f4bdc35bd7c62478db41e/attachments/681a1a2cedddbafedec5f95e/download/JOEI_Training-_Universal_Search.pdf"
export const CALENDAR_VIEW_AID = "https://trello.com/1/cards/674f4bdc35bd7c62478db41e/attachments/6818f81bc96c5e1b4489864f/download/JOEI_Training-_Calendar.pdf"
export const DOWNLOAD_EXCEL_AID = "https://trello.com/1/cards/674f4bdc35bd7c62478db41e/attachments/6818d1710bba29d1d0843d83/download/JOEI_Training-_Download_Excel.pdf"